import React, { PropsWithChildren } from 'react'

import { StyledDivider } from './DropdownMenuStyled'

export const DropdownMenuDivider: React.FC<PropsWithChildren<any>> = () => (
  <StyledDivider />
)

export default DropdownMenuDivider
